import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import facade from "./plugins/facade";
import money from "./plugins/money";
import fragment from "./plugins/fragment";
import quill from "./plugins/quill";
import tooltip from "./plugins/tooltip";
import "./main.sass";

// Adding Components Base
import "@/components/base";
// Adding Layouts
import "@/layouts";
// Adding Modules
import "@/modules/auth";
import "@/modules/quotation";
import "@/modules/modality";
import "@/modules/insurance_company";
import "@/modules/brokers";
import "@/modules/economic_group";
import "@/modules/court";
import "@/modules/policy";
import "@/modules/user";
import "@/modules/profile";
import "@/modules/me";
import "@/modules/term";
import "@/modules/reason_cancel";
import "@/modules/office";
import "@/modules/endorsement";
import "@/modules/legacy_importation";
import "@/modules/dashboard";
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  facade,
  money,
  fragment,
  quill,
  tooltip,
  render: h => h(App)
}).$mount("#app");
